(function (window, document, undefined) {
  'use strict';
  
  var hasSubmenu = document.querySelectorAll('[data-id]');
  var visible = 'visible';
  var i = 0;
  var overlay = document.getElementById("overlay");
  
  function showSubmenu(event) {
    var self = this;
    var submenu = document.getElementById(self.dataset.id);
    event.preventDefault();
    
    if (!$(submenu).hasClass(visible)) {
      $('.nav-link').removeClass(visible);
      $('.submenu').removeClass(visible);
      overlay.classList.add(visible);
    } else {
      $("#overlay").removeClass(visible);
    }
    
    self.classList.toggle(visible);
    submenu.classList.toggle(visible);
  }
  
  function removeChildClass(el) {
    if (el.classList.contains(visible)) {
      el.classList.remove(visible);
    }
  }
  
  for (i = 0; i < hasSubmenu.length; i++) {
    hasSubmenu[i].addEventListener('click', showSubmenu);
  }
})(window, document);

$(document).ready(function () {
  $('.dragger')
    .mousedown(function (event) {
      $(this)
        .data('down', true)
        .data('x', event.clientX)
        .data('scrollLeft', this.scrollLeft)
        .addClass("dragging");
      return false;
    })
    .mouseup(function (event) {
      $(this)
        .data('down', false)
        .removeClass("dragging");
    })
    .mousemove(function (event) {
      if ($(this).data('down') == true) {
        this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
      }
    })
    .mousewheel(function (event, delta) {
      this.scrollLeft -= (delta * 30);
    })
    .css({
      'overflow': 'hidden',
      'cursor': '-moz-grab'
    });
  
  $(window).mouseout(function (event) {
    if ($('.team-form-data').data('down')) {
      try {
        if (event.originalTarget.nodeName == 'BODY' || event.originalTarget.nodeName == 'HTML') {
          $('.team-form-data').data('down', false);
        }
      } catch (e) { }
    }
  });
});

$(".secondary-nav a[href^='#']").on('click', function (event) {
  var target = this.hash;
  event.preventDefault();
  var navOffset = $('.secondary-nav').height();
  
  return $('html, body').animate({
    scrollTop: navOffset
  }, 300, function () {
    return window.history.pushState(null, null, target);
  });
});

$(".secondary-nav li").click(function () {
  centerLI(this, '.main-nav');
  
  if (!$(this).hasClass('dropdown')) {
    $('.nav-link').removeClass('visible');
    $('.submenu').removeClass('visible');
    $('#overlay').removeClass('visible');
  }
});

function centerLI(target, outer) {
  var out = $(outer);
  var tar = $(target);
  var x = out.width() - 50;
  var y = tar.outerWidth(true);
  var z = tar.index();
  var q = 0;
  var m = out.find('li');
  
  for (var i = 0; i < z; i++) {
    q += $(m[i]).outerWidth(true);
  }
  
  out.animate({
    scrollLeft: Math.max(0, q - (x - y) / 2)
  }, 500);
}

$(document).mouseup(function (e) {
  var container = $("#secondary-nav");
  
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.nav-link').removeClass('visible');
    $('.submenu').removeClass('visible');
    $('#overlay').removeClass('visible');
  }
});